"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsocketServerConnector = void 0;
const geoip_location_1 = require("@streamr/geoip-location");
const WebsocketClientConnector_1 = require("./WebsocketClientConnector");
const WebsocketServer_1 = require("./WebsocketServer");
const identifiers_1 = require("../../identifiers");
const AutoCertifierClientFacade_1 = require("./AutoCertifierClientFacade");
const DhtRpc_1 = require("../../../generated/packages/dht/protos/DhtRpc");
const ConnectionManager_1 = require("../ConnectionManager");
const utils_1 = require("@streamr/utils");
const connectivityRequestHandler_1 = require("../connectivityRequestHandler");
const IConnection_1 = require("../IConnection");
const version_1 = require("../../helpers/version");
const shuffle_1 = __importDefault(require("lodash/shuffle"));
const connectivityChecker_1 = require("../connectivityChecker");
const Handshaker_1 = require("../Handshaker");
const WebsocketClientConnectorRpcRemote_1 = require("./WebsocketClientConnectorRpcRemote");
const DhtRpc_client_1 = require("../../../generated/packages/dht/protos/DhtRpc.client");
const errors_1 = require("../../helpers/errors");
const Err = __importStar(require("../../helpers/errors"));
const Connectivity_1 = require("../../helpers/Connectivity");
const PendingConnection_1 = require("../PendingConnection");
const logger = new utils_1.Logger(module);
// TODO: Move server starting logic including autocertification and connectivity checking to WebsocketServer.ts?
class WebsocketServerConnector {
    websocketServer;
    geoIpLocator;
    ongoingConnectRequests = new Map();
    host;
    autoCertifierClient;
    selectedPort;
    localPeerDescriptor;
    abortController = new AbortController();
    options;
    constructor(options) {
        this.options = options;
        this.websocketServer = options.portRange ? new WebsocketServer_1.WebsocketServer({
            portRange: options.portRange,
            tlsCertificate: options.tlsCertificate,
            maxMessageSize: options.maxMessageSize,
            enableTls: options.serverEnableTls
        }) : undefined;
        this.host = options.host;
    }
    async start() {
        if (!this.abortController.signal.aborted && this.websocketServer) {
            this.websocketServer.on('connected', (connection) => {
                const serverSocket = connection;
                const urlParams = new URLSearchParams(serverSocket.resourceURL.query ?? '');
                const action = urlParams.get('action');
                logger.trace('WebSocket client connected', { action, remoteAddress: serverSocket.getRemoteIpAddress() });
                if (action === 'connectivityRequest') {
                    (0, connectivityRequestHandler_1.attachConnectivityRequestHandler)(serverSocket, this.geoIpLocator);
                }
                else if (action === 'connectivityProbe') {
                    // no-op
                }
                else {
                    // The localPeerDescriptor can be undefined here as the WS server is used for connectivity checks
                    // before the localPeerDescriptor is set during start.
                    // Handshaked connections should be rejected before the localPeerDescriptor is set.
                    // eslint-disable-next-line no-lonely-if
                    if (this.localPeerDescriptor !== undefined) {
                        this.attachHandshaker(connection);
                    }
                    else {
                        logger.trace('incoming Websocket connection before localPeerDescriptor was set, closing connection');
                        connection.close(false).catch(() => { });
                    }
                }
            });
            if (this.options.geoIpDatabaseFolder) {
                const geoIpLocator = new geoip_location_1.GeoIpLocator(this.options.geoIpDatabaseFolder);
                try {
                    await geoIpLocator.start();
                    this.geoIpLocator = geoIpLocator;
                }
                catch (err) {
                    logger.error('Failed to start GeoIpLocator', { err });
                }
            }
            const port = await this.websocketServer.start();
            this.selectedPort = port;
        }
    }
    attachHandshaker(connection) {
        // TODO: use createIncomingHandshaker here?
        const handshaker = new Handshaker_1.Handshaker(this.localPeerDescriptor, connection);
        handshaker.once('handshakeRequest', (localPeerDescriptor, remoteProtocolVersion, remotePeerDescriptor) => {
            this.onServerSocketHandshakeRequest(localPeerDescriptor, connection, handshaker, remoteProtocolVersion, remotePeerDescriptor);
        });
    }
    onServerSocketHandshakeRequest(remotePeerDescriptor, websocketServerConnection, handshaker, remoteProtocolVersion, targetPeerDescriptor) {
        const nodeId = (0, identifiers_1.toNodeId)(remotePeerDescriptor);
        if (this.ongoingConnectRequests.has(nodeId)) {
            const { pendingConnection, delFunc } = this.ongoingConnectRequests.get(nodeId);
            if (!(0, version_1.isMaybeSupportedProtocolVersion)(remoteProtocolVersion)) {
                (0, Handshaker_1.rejectHandshake)(pendingConnection, websocketServerConnection, handshaker, DhtRpc_1.HandshakeError.UNSUPPORTED_PROTOCOL_VERSION);
                delFunc();
            }
            else if (targetPeerDescriptor && !(0, identifiers_1.areEqualPeerDescriptors)(this.localPeerDescriptor, targetPeerDescriptor)) {
                (0, Handshaker_1.rejectHandshake)(pendingConnection, websocketServerConnection, handshaker, DhtRpc_1.HandshakeError.INVALID_TARGET_PEER_DESCRIPTOR);
                delFunc();
            }
            else {
                (0, Handshaker_1.acceptHandshake)(handshaker, pendingConnection, websocketServerConnection);
            }
        }
        else {
            const pendingConnection = new PendingConnection_1.PendingConnection(remotePeerDescriptor);
            if (!(0, version_1.isMaybeSupportedProtocolVersion)(remoteProtocolVersion)) {
                (0, Handshaker_1.rejectHandshake)(pendingConnection, websocketServerConnection, handshaker, DhtRpc_1.HandshakeError.UNSUPPORTED_PROTOCOL_VERSION);
            }
            else if (targetPeerDescriptor && !(0, identifiers_1.areEqualPeerDescriptors)(this.localPeerDescriptor, targetPeerDescriptor)) {
                (0, Handshaker_1.rejectHandshake)(pendingConnection, websocketServerConnection, handshaker, DhtRpc_1.HandshakeError.INVALID_TARGET_PEER_DESCRIPTOR);
            }
            else if (this.options.onNewConnection(pendingConnection)) {
                (0, Handshaker_1.acceptHandshake)(handshaker, pendingConnection, websocketServerConnection);
            }
            else {
                (0, Handshaker_1.rejectHandshake)(pendingConnection, websocketServerConnection, handshaker, DhtRpc_1.HandshakeError.DUPLICATE_CONNECTION);
            }
        }
    }
    async checkConnectivity(allowSelfSignedCertificate) {
        // TODO: this could throw?
        if (this.abortController.signal.aborted) {
            return {
                host: '127.0.0.1',
                natType: ConnectionManager_1.NatType.UNKNOWN,
                ipAddress: (0, utils_1.ipv4ToNumber)('127.0.0.1'),
                protocolVersion: version_1.LOCAL_PROTOCOL_VERSION
            };
        }
        if (!this.options.entrypoints || this.options.entrypoints.length === 0) {
            // return connectivity info given in options
            return {
                host: this.host,
                natType: ConnectionManager_1.NatType.OPEN_INTERNET,
                websocket: {
                    host: this.host,
                    port: this.selectedPort,
                    tls: this.options.tlsCertificate !== undefined
                },
                // TODO: Resolve the given host name or or use as is if IP was given. 
                ipAddress: (0, utils_1.ipv4ToNumber)('127.0.0.1'),
                protocolVersion: version_1.LOCAL_PROTOCOL_VERSION
            };
        }
        const shuffledEntrypoints = (0, shuffle_1.default)(this.options.entrypoints);
        while (shuffledEntrypoints.length > 0 && !this.abortController.signal.aborted) {
            const entryPoint = shuffledEntrypoints[0];
            try {
                // Do real connectivity checking
                const connectivityRequest = {
                    port: this.selectedPort ?? connectivityRequestHandler_1.DISABLE_CONNECTIVITY_PROBE,
                    host: this.host,
                    tls: this.websocketServer ? this.options.serverEnableTls : false,
                    allowSelfSignedCertificate
                };
                if (!this.abortController.signal.aborted) {
                    return await (0, connectivityChecker_1.sendConnectivityRequest)(connectivityRequest, entryPoint);
                }
                else {
                    throw new Err.ConnectionFailed('ConnectivityChecker is destroyed');
                }
            }
            catch (err) {
                const error = `Failed to connect to entrypoint with id ${(0, identifiers_1.toNodeId)(entryPoint)} `
                    + `and URL ${(0, WebsocketClientConnector_1.connectivityMethodToWebsocketUrl)(entryPoint.websocket)}`;
                logger.error(error, { err });
                shuffledEntrypoints.shift();
                await (0, utils_1.wait)(2000, this.abortController.signal);
            }
        }
        throw new errors_1.WebsocketServerStartError(`Failed to connect to the entrypoints after ${this.options.entrypoints.length} attempts\n`
            + `Attempted hosts: ${this.options.entrypoints.map((entry) => `${entry.websocket.host}:${entry.websocket.port}`).join(', ')}`);
    }
    async autoCertify() {
        this.autoCertifierClient = new AutoCertifierClientFacade_1.AutoCertifierClientFacade({
            configFile: this.options.autoCertifierConfigFile,
            transport: this.options.autoCertifierTransport,
            url: this.options.autoCertifierUrl,
            wsServerPort: this.selectedPort,
            setHost: (hostName) => this.setHost(hostName),
            updateCertificate: (certificate, privateKey) => this.websocketServer.updateCertificate(certificate, privateKey)
        });
        logger.trace(`AutoCertifying subdomain...`);
        await this.autoCertifierClient.start();
    }
    setHost(hostName) {
        logger.trace(`Setting host name to ${hostName}`);
        this.host = hostName;
    }
    connect(targetPeerDescriptor) {
        const nodeId = (0, identifiers_1.toNodeId)(targetPeerDescriptor);
        if (this.ongoingConnectRequests.has(nodeId)) {
            return this.ongoingConnectRequests.get(nodeId).pendingConnection;
        }
        return this.requestConnectionFromPeer(this.localPeerDescriptor, targetPeerDescriptor);
    }
    requestConnectionFromPeer(localPeerDescriptor, targetPeerDescriptor) {
        setImmediate(() => {
            const remoteConnector = new WebsocketClientConnectorRpcRemote_1.WebsocketClientConnectorRpcRemote(localPeerDescriptor, targetPeerDescriptor, this.options.rpcCommunicator, DhtRpc_client_1.WebsocketClientConnectorRpcClient);
            remoteConnector.requestConnection().then(() => {
                logger.trace('Sent WebsocketConnectionRequest notification to peer', { targetPeerDescriptor });
            }, (err) => {
                logger.debug('Failed to send WebsocketConnectionRequest notification to peer ', {
                    error: err, targetPeerDescriptor
                });
            });
        });
        const pendingConnection = new PendingConnection_1.PendingConnection(targetPeerDescriptor);
        const nodeId = (0, identifiers_1.toNodeId)(targetPeerDescriptor);
        // TODO: can this leak?
        const delFunc = () => {
            pendingConnection.off('connected', delFunc);
            pendingConnection.off('disconnected', delFunc);
            this.ongoingConnectRequests.delete(nodeId);
        };
        pendingConnection.on('connected', delFunc);
        pendingConnection.on('disconnected', delFunc);
        this.ongoingConnectRequests.set(nodeId, { pendingConnection, delFunc });
        return pendingConnection;
    }
    isPossibleToFormConnection(targetPeerDescriptor) {
        const connectionType = (0, Connectivity_1.expectedConnectionType)(this.localPeerDescriptor, targetPeerDescriptor);
        return (connectionType === IConnection_1.ConnectionType.WEBSOCKET_SERVER);
    }
    setLocalPeerDescriptor(localPeerDescriptor) {
        this.localPeerDescriptor = localPeerDescriptor;
    }
    async destroy() {
        this.abortController.abort();
        const requests = Array.from(this.ongoingConnectRequests.values());
        await Promise.allSettled(requests.map((ongoingConnectRequest) => ongoingConnectRequest.pendingConnection.close(true)));
        await this.websocketServer?.stop();
        this.geoIpLocator?.stop();
    }
}
exports.WebsocketServerConnector = WebsocketServerConnector;
//# sourceMappingURL=WebsocketServerConnector.js.map